import React from 'react'
import { Box, Typography } from '@mui/material'
import { UnpaidCharge } from './types'

interface UnpaidChargeCardProps {
    charge: UnpaidCharge
}

const formatCurrency = (value: string | number) => {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(Number(value))
}

const formatDate = (isoDate: string) => {
    const date = new Date(isoDate)
    return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    })
}

export const UnpaidChargeCard: React.FC<UnpaidChargeCardProps> = ({ charge }) => {
    return (
        <Box
            sx={{
                px: 2,
                py: 1.5,
                borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                '&:last-child': { borderBottom: 'none' },
            }}
        >
            <Box>
                <Typography
                    variant="body2"
                    sx={{ fontWeight: 500, color: '#fff' }}
                >
                    {charge.description || charge.charge_code_name}
                </Typography>
                {charge.transaction_date && (
                    <Typography variant="caption" sx={{ color: '#94a3b8' }}>
                        {formatDate(charge.transaction_date)}
                    </Typography>
                )}
            </Box>
            <Typography
                variant="body2"
                sx={{ fontWeight: 600, color: '#f59e0b', whiteSpace: 'nowrap', ml: 2 }}
            >
                {formatCurrency(charge.amount)}
            </Typography>
        </Box>
    )
}
